function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import AllhomesActMap from '@domain-group/fe-co-allhomes-act-map';
import WMSMapLayer from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer';
import WMSMapLayerLegend from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer-legend';
var MapPin = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-map/static/property-pin_303bd30b.png";
import LandDetailsPanel from './land-details-panel';
import DesktopBlockmap from './desktop-blockmap';
import * as styles from './land-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class LandDetails extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "createMarker", (center, htmlFriendlyDescription, src) => ({
      center,
      htmlFriendlyDescription,
      icon: {
        src,
        anchor: [0.5, 0.5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction'
      }
    }));
    _defineProperty(this, "createListingMarker", () => ({
      center: this.props.center,
      htmlFriendlyDescription: this.props.listingDescription,
      icon: {
        src: this.props.listingIconSrc,
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels'
      }
    }));
    _defineProperty(this, "retrieveSchoolMarkers", layerKey => {
      var url = "".concat(this.props.schoolMarkerEndpoint, "/").concat(layerKey);
      return fetch(url).then(response => {
        if (response.ok) {
          return response.json();
        }
        return [];
      }).catch(() => []);
    });
    _defineProperty(this, "prepareSchoolMarkers", layerKey => {
      if (this.schoolMarkerMap[layerKey]) {
        return Promise.resolve();
      }
      return this.retrieveSchoolMarkers(layerKey).then(schoolMarkers => {
        this.schoolMarkerMap[layerKey] = schoolMarkers.map(schoolMarker => {
          var htmlFriendlyDescription = "<p>".concat(schoolMarker.title, "</p>").concat(schoolMarker.content);
          return this.createMarker([schoolMarker.longitude, schoolMarker.latitude], htmlFriendlyDescription, schoolMarker.markerFileUrl);
        });
      });
    });
    _defineProperty(this, "updateMapState", newMapState => {
      this.setState(newMapState);
    });
    _defineProperty(this, "updateOverlay", (layerKey, isSchool) => {
      this.setState({
        enabledOverlay: WMSMapLayer[layerKey],
        enabledMarkers: [this.createListingMarker()],
        legend: isSchool ? null : WMSMapLayerLegend[layerKey]
      });
      this.props.onOverlaySelect(layerKey);
    });
    _defineProperty(this, "updateSchools", layerKey => {
      this.schoolMarkerMap = this.schoolMarkerMap || {};
      var enabledMarkers = [this.createListingMarker()];
      var enabledOverlay = WMSMapLayer[layerKey];
      this.prepareSchoolMarkers(layerKey).then(() => {
        var currentOverlay = this.state.enabledOverlay;
        enabledMarkers.push(...this.schoolMarkerMap[layerKey]);
        this.setState({
          enabledOverlay,
          enabledMarkers
        });

        // Prevent double-send of school selection
        if (currentOverlay !== enabledOverlay) {
          this.props.onOverlaySelect(layerKey);
        }
      });
    });
    this.state = {
      center: this.props.center,
      zoom: this.props.zoom,
      enabledMarkers: [this.createListingMarker()]
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.state.enabledOverlay, nextState.enabledOverlay) || !isEqual(this.state.enabledMarkers, nextState.enabledMarkers);
  }
  render() {
    var overlayLayers = [];
    if (this.state.enabledOverlay) {
      overlayLayers.push(this.state.enabledOverlay);
    }
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX(AllhomesActMap, {
      css: styles.map,
      onMapStateChange: this.updateMapState,
      center: this.state.center,
      zoom: this.state.zoom,
      overlayLayers: overlayLayers,
      wmsUrl: this.props.wmsUrl,
      features: this.state.enabledMarkers,
      onInteract: this.props.onInteract
    }), this.props.displayBottom && ___EmotionJSX("div", {
      css: styles.bottomSection
    }, this.props.blockInfo && ___EmotionJSX("div", {
      css: styles.bottomLeftSection
    }, ___EmotionJSX(DesktopBlockmap, this.props.blockInfo)), ___EmotionJSX("div", {
      css: styles.bottomRightSection
    }, ___EmotionJSX(LandDetailsPanel, {
      legend: this.state.legend,
      enabledOverlay: this.state.enabledOverlay,
      onUpdateSchool: this.updateSchools,
      onUpdateOverlay: this.updateOverlay
    }))));
  }
}
LandDetails.propTypes = {
  wmsUrl: PropTypes.string.isRequired,
  center: PropTypes.arrayOf(PropTypes.number).isRequired,
  zoom: PropTypes.number,
  listingDescription: PropTypes.string.isRequired,
  listingIconSrc: PropTypes.string,
  schoolMarkerEndpoint: PropTypes.string.isRequired,
  onOverlaySelect: PropTypes.func,
  onInteract: PropTypes.func,
  blockInfo: PropTypes.shape(DesktopBlockmap.propTypes),
  displayBottom: PropTypes.bool
};
LandDetails.defaultProps = {
  zoom: 7,
  listingIconSrc: MapPin,
  onOverlaySelect: () => {},
  onInteract: () => {},
  blockInfo: null,
  displayBottom: true
};
export default LandDetails;